import { faRightLeft, faMagnifyingGlass, faCircleExclamation, faFileExcel, faPlus, faRefresh, faClone, faBackward, faFloppyDisk, faCheck, faPen, faBan, faCheckCircle, faWarning, faCalendarCheck, faTrash, faCogs, faCreditCard, faGasPump, faLineChart, faLocationDot, faRoad, faTint, faTractor, faUserTie, faSeedling, faExclamationTriangle, faEyeSlash, faEye, faArrowRightArrowLeft, faBoxArchive, faUsd, faCircleInfo, faUserShield, faScrewdriverWrench, faDashboard } from "@fortawesome/free-solid-svg-icons";

export const ESRI_APIKEY = "AAPK392a310f2a96449380cc087e6008b0d8no4SHm_DUPpEe_ZEkoiNzl9jWADLn5rjHQXw3z9tMiAHnhAjR-gYpelkkmuEmfSs";

/*EndPoints*/
export const PREFERENCE_ENDPOINT = "/common/preferences";
export const CHANGE_PASSWORD_ENDPOINT = "/account/password/change";
export const LOGIN_ENDPOINT = "/account/authentication";
export const CURRENT_USER_ENDPOINT = "/users/current";
export const VERSION_BAG_ENDPOINT = "/platform/version";

export const MAINTENANCE_OPERATION_ENDPOINT = "/maintenance/operation";
export const MAINTENANCE_PLAN_ENDPOINT_OFCUSTOMER = "/maintenance/plan/ofCustomer";
export const MAINTENANCE_PLAN_ENDPOINT_OPERATIONS_BLOCKS = "/maintenance/plan/operationsBlocks";
export const MAINTENANCE_OPERATION_ENDPOINT_OPERATIONS_BLOCKS = "/maintenance/operation/operationsBlock";
export const MAINTENANCE_LAST_ENGINE_HOURS = "/maintenance/lastEngineHours/";
export const MAINTENANCE_PENDING ="/maintenance/pending/";
export const MAINTENANCE_PLAN_ENDPOINT_OFVEHICLE = "/maintenance/plan/ofVehicle";
export const MAINTENANCE_PLAN_ENDPOINT = "/maintenance/plan";
export const MAINTENANCE_PLAN_DELEATE_ENDPOINT = "/maintenance/plan/operationsBlock/";
export const MAINTENANCE_EDIT_ENDPOINT = "/maintenance/pending/";
export const MAINTENANCE_EDIT_ENDPOINT_OFVEHICLE = "/maintenance/pending/";
export const MAINTENANCE_HISTORY = "/maintenance/history/";
export const MAINTENANCE_PLAN_CUSTOMPLAN = "/maintenance/plan/customPlan";
export const MAINTENANCE_PLAN_CUSTOMPLAN_UPDATE = "/maintenance/plan/customPlan/update";
export const MAINTENANCE_OPERATION_OPERATION_BLOCK_UPDATE = "/maintenance/operation/operationsBlock/update";
export const MAINTENANCE_PENDING_OFVEHICLE = "/maintenance/pending/ofVehicle/";
export const MAINTENANCE_HISTORY_OFVEHICLE = "/maintenance/history/ofVehicle/";
export const RESET_PASSWORD_ENDPOINT = "/account/password/askreset";
export const CONFIRM_RESET_PASSWORD_ENDPOINT = "/account/password/confirmreset";
export const ALERTS_BY_CUSTOMER_ENDPOINT = "/alerting/ofCustomer";
export const VEHICLES_BY_CUSTOMER_ENDPOINT = "/vehicles/ofCustomer";
export const DATE_LAST_VEHICLE_POLISION = "/tracking/getDateLastVehiclePosition/ofCustomer/";
export const DATE_LAST_JOURNEY = "/tracking/getDateLastJourney/ofCustomer/";
export const GEOFENCING_BY_CUSTOMER_ENDPOINT = "/geofencing/ofCustomer";
export const TACHO_ACTIVITIES_ENDPOINT = "/tacho/cardData/driveractivities";
export const CUSTOMERS_BY_CUSTOMER_ENDPOINT = "/customers/ofCustomer";
export const CUSTOMERS_BY_CUSTOMER_ENDPOINT_20 = "v1/assets/customers/ofCustomer";
export const TRACKING_JOURNEY_ENDPOINT = "/tracking/journey";
export const ALERTING_ENDPOINT = "/alerting";
export const ALERT_CHANNELS_ENDPOINT = "/common/alertingNotificationChannels";
export const FLEETS_OF_CUSTOMER_ENDPOINT = "/fleets/ofCustomer/";
export const VEHICLES_OF_CUSTOMER_ENDPOINT = "/vehicles/ofCustomer/";
export const USERS_OF_CUSTOMER_ENDPOINT = "/users/ofCustomer/";
export const USERS_ACTIVATION_EMAIL_ENDPOINT = "/users/sendActivationEmail";
export const USERS_LOCK_TOGGLE_ENDPOINT = "/users/lock/toggle";
export const USERS_GROUP_ENDPOINT = "/users/group";
export const ONE_USER_ENDPOINT = "/users/user";
export const USERS_ENDPOINT = "/users";
export const USRES_BY_CUSTOMER_ENDPOINT = "/users/ofCustomer";
export const GROUPS_BY_CUSTOMER_ENDPOINT = "/groups/ofCustomer";
export const FLEETS_ENDPOINT = "/fleets";
export const FLEETS_INFO_ENDPOINT = "/fleets/fleet";
export const TEAMS_BY_CUSTOMER_ENDPOINT = "/teams/ofCustomer";
export const DRIVERSS_BY_CUSTOMER_ENDPOINT = "/myassets/drivers/ofCustomer";
export const ONE_TEAM_ENDPOINT = "/teams/team";
export const TEAMS_ENDPOINT = "/teams";
export const SEARCH_DEVICES_ENDPOINT = "/devices/search";
export const ONE_DEVICE_ENDPOINT = "/devices/device";
export const DEVICES_ENDPOINT = "/devices";
export const DEVICE_MODELS_ENDPOINT = "/common/deviceModels";
export const INSTALLATION_TYPE_ENDPOINT = "/common/installationTypes";
export const COUNTRIES_ENDPOINT = "/common/countries";
export const DEVICES_CARRIERS_ENDPOINT = "/common/deviceCarriers";
export const CONFIG_OF_DEVICES_ENDPOINT = "/devices/configuration/ofDevice";
export const DEVICES_HISTORY_ENDPOINT = "/devices/historicalBindingsOf";
export const DEVICES_REPORT_ENDPOINT = "/devices/report/ofDevice";
export const DEVICES_SENDSMS_ENDPOINT = "/devices/sendSMS";
export const DEVICES_CONFIG_ENDPOINT = "/devices/configuration";
export const DRIVERS_BY_CUSTOMER_ENDPOINT = "/drivers/ofCustomer";
export const DRIVERS_NAMESAKE_BY_CUSTOMER_ENDPOINT = "/drivers/namesake/ofCustomer";
export const MERGE_NAMESAKE_ENDPOINT = "/drivers/namesake/merge";
export const DRIVERS_ASSIGN_ENDPOINT = "/drivers/assign/toCustomer";
export const DRIVERS_UNASSIGN_ENDPOINT = "/drivers/unassign";
export const DRIVER_FORCEDDD_ENDPOINT = "/drivers/driver/forceDDD";
export const ONE_DRIVER_ENDPOINT = "/drivers/driver";
export const DRIVERS_MOVE_CUSTOMER_ENDPOINT = "/drivers/move/toCustomer";
export const ACCOUNT_ACTIVATE_ENDPOINT = "/account/activate";
export const ONE_GROUP_ENDPOINT = "/groups/group";
export const GROUPS_ENDPOINT = "/groups";
export const FEATURES_CUSTOMER_ENDPOINT = "/features/ofCustomer";
export const ONE_CUSTOMER_ENDPOINT = "/customers/customer";
export const DEFAULT_FMW_ENDPOINT = "/fmw/default/byCustomer";
export const CANMAP_OFCUSTOMER_ENDPOINT = "/canmaps/ofCustomer";
export const CANMAP_CUSTOMER_ENDPOINT = "/v2/canmaps/ofCustomer/";
export const CANMAP_DISSACIATION = "/v2/canmaps/vehicle/dissociation";
export const CANMAP_ENDPOINT = "/v2/canmaps/";
export const CANMAP_ASSIGNTO_ENDPOINT = "/canmaps/map/assignTo";
export const CANMAP_TYPE_GET_SUFFIX = "/canmaptype";
export const FIRMWARE_LIST_ENDPOINT = "/fmw/pckgs";
export const FIRMWARE_INFO_ENDPOINT = "/fmw/pckg";
export const FIRMWAREV3_REQ_UPLOAD = "v1/firmware/pckgv3/requestUpload";
export const FIRMWAREV3_POST_UPLOAD = "v1/firmware/pckgv3/confirmUpload";
export const DEVICE_MODELS_LIST_ENDPOINT = "/common/deviceModels";
export const ASSIGN_FIRMWARE_ENDPOINT = "/fmw/assign";
export const IMPLEMENT_TYPES_ENDPOINT = "/common/domainValues?domain=ImplementTypes&language=";
export const IMPLEMENTS_OF_CUSTOMER_ENDPOINT = "/implements/ofCustomer/";
export const IMPLEMENT_ENDPOINT = "/implement/";
export const UNASSIGN_IMPLEMENT_ENDPOINT = "/implements/unassign?uidImplements=";
export const ASSIGN_IMPLEMENT_ENDPOINT = "/implements/assign/toCustomer";
export const PUT_IMPLEMENT_ENDPOINT = "/implements/implement";
export const CHANGE_IMPLEMENT_CUSTOMER_ENDPOINT = "/implements/move/toCustomer/";
export const ONE_VEHICLE_ENDPOINT = "/vehicles/vehicle";
export const VEHICLE_MOVE_ENDPOINT = "/vehicles/move/toCustomer";
export const FMWTOKEN_ENDPOINT = "/fmw/getRepoToken";
export const MYASSETS_VEHICLE_ENDPOINT = "/myassets/vehicles/ofCustomer/";

export const MYASSETS_FLEETS_OFCUSTOMER = "/myassets/fleets/ofCustomer/";
export const MYASSETS_TEAMS_OFCUSTOMER = "/myassets/teams/ofCustomer/";
export const MYASSETS_VEHICLES_OFCUSTOMER = "/myassets/vehicles/ofCustomer/";
export const MYASSETS_VEHICLES_OFCUSTOMER_20 = "v1/assets/vehicles/ofCustomer/";
export const MYASSETS_DRIVERS_OFCUSTOMER = "/myassets/drivers/ofCustomer/";

/* Parametri filtro veicoli default caricamento dei dati*/
export const VEHICLE_FILTER_INCLUDE_CHILDREN = true;
export const VEHICLE_FILTER_ALSO_DISABLED = true;
export const VEHICLE_FILTER_ALSO_DATA_HIDDEN = true;
export const VEHICLE_FILTER_SUBSCRIBED = true;
export const VEHICLE_FILTER_HAVE_COMMUNICATED = true;

/* Parametri filtro veicoli default per FIltri*/
export const SET_VEHICLE_FILTER_INCLUDE_CHILDREN = false;
export const SET_VEHICLE_FILTER_ALSO_DISABLED = true;
export const SET_VEHICLE_FILTER_ALSO_DATA_HIDDEN = false;
export const SET_VEHICLE_FILTER_HAVE_COMMUNICATED = false;

// Parmetnro per max numero di assets da poter caricare
export const MAX_ASSETS_LOAD = 100;

/* UI Configuration */
export const MYASSETS_DRIVERS_OFCUSTOMER_20 = "v1/assets/drivers/ofCustomer/";

/* Segnali veicolo / Report Industry 4.0 (TELEOHW-926) — endpoint generico, nessun riferimento a un
   customer specifico nel nome. Sostituisce "v1/ucontrol/vehicles/" (rinominato 2026-10-24, su
   richiesta esplicita: i contratti non devono nominare un cliente). Usato per catalog
   (GET .../{uidVehicle}/catalog) e per lo storico scritture (.../writes). Le primitive dati del
   report (/v2/vehicle-signals/...) sono chiamate dal template jsreport, non dal FE. */
export const VEHICLE_SIGNALS_ENDPOINT = "v1/vehicle-signals/";
export const FARM_OFCUSTOMER_ENDPOINT = "/farm/ofCustomer";
export const FARM_LOGBOOKSOFCUSTOMER_ENDPOINT = "/farm/logbooks/ofCustomer";
export const FARM_LOGBOOKS_ENDPOINT = "/farm/logbooks";
export const FARM_STOPLOGBOOKS_ENDPOINT = "/farm/logbook/stop";
export const FARM_LOGBOOKSSCHEDULES_ENDPOINT = "/farm/logbookSchedules";
export const FARM_LOGBOOKSSCHEDULES_OFCUSTOMER_ENDPOINT = "/farm/logbookSchedules/ofCustomer";
export const FARM_LOGBOOKSSCHEDULES_OFCUSTOMER_WITHFILTER = "/farm/logbookSchedules/ofCustomerWithFilter";
export const DOMAIN_VALUES_ENDPOINT = "/common/domainValues";
export const ASSET_VEHICLES_OFCUSTOMER_ENDPOINT = "/myassets/vehicles/ofCustomer";
export const ASSET_DRIVERS_OFCUSTOMER_ENDPOINT = "/myassets/drivers/ofCustomer";
export const ASSET_IMPLEMENTS_OFCUSTOMER_ENDPOINT = "/myassets/implements/ofCustomer";
export const HOMEPAGE_MAP_OFCUSTOMER_ENDPOINT = "/homepage/map/ofCustomer";
export const GET_FAULTS_ENDPOINT_OLD = "/fault/getFaults";
export const GET_FAULTS_ENDPOINT = "v1/faults/getFaults";
export const GET_FAULTS_BY_IDRAW_ENDPOINT = "v1/faults/getFaultsByIdRaw/ofVehicle/:uidVehicle/ofIdRaw/:idRaw";
export const GET_VEHICLES_SEARCH = "/myassets/vehicles/search";
export const GET_DEVICES_SEARCH = "/myassets/devices/search";
export const GET_DRIVERS_SEARCH = "/myassets/drivers/search";
export const LOGINAS_OF_CUSTOMER = "/loginas/customer";
export const LOGINAS_USER = "/loginas/user";
export const VEHICLE_MODELS = "/vehicleModels/list";
export const PORTAL_CONFIG = "/customers/ofCustomer/";
export const VEHICLE_MODELS_DETAIL = '/vehicleModels';
export const VEHICLE_MODEL_IMPORT = '/vehicleModels/import';
export const FLEETS = '/fleets'
export const MISCELLANEUS_ENDPOINT = '/miscellaneous';
export const TRAILERS_BY_CUSTOMER_ENDPOINT = '/etrailer/ofCustomer';

/* PowerBI Endpoints */
export const POWERBI_AUTH_ENDPOINT = "/powerbi/get-access-token/";

/* Agrirouter Endpoints */
// registry page endpoints
export const AGRIROUTER_AUTHORIZATION_ENDPOINT = "/onboard/authorizationUrl?redirectUrl=";
export const AGRIROUTER_ONBOARD_TELEMETRY_ENDPOINT = "/onboard/telemetryPlatform";
export const AGRIROUTER_OFFBOARD_TELEMETRY_ENDPOINT = "/offboard/telemetryPlatform";
export const AGRIROUTER_REONBOARD_TELEMETRY_ENDPOINT = "/reonboard/telemetryPlatform";
export const AGRIROUTER_ONBOARD_VCU_ENDPOINT = "/onboard/:deviceId";
export const AGRIROUTER_OFFBOARD_VCU_ENDPOINT = "/offboard/:deviceId";
export const AGRIROUTER_ONBOARD_CHECK = "/onboard/:uidARDevice/check"
export const AGRIROUTER_OFFBOARD_VCU_RESET = "/offboard/vcu/reset"
export const AGRIROUTER_ONBOARD_CAPABILITIES = "/onboard/:uidARDevice/capabilities"
export const AGRIROUTER_ONBOARD_VCU_STATUS_ENDPOINT = "/onboard/:deviceId/status";
export const AGRIROUTER_ONBOARD_TEL_STATUS_ENDPOINT = "/onboard/telemetryPlatform/ofCustomer/:customerId/status";
export const AGRIROUTER_CREATE_DEVICE_ENDPOINT = "/ardevices";
export const AGRIROUTER_UPDATE_DEVICE_ENDPOINT = "/ardevices/:deviceId";
export const AGRIROUTER_GET_DEVICES_ENDPOINT = "/ardevices/ofCustomer/:uidCustomer";
export const AGRIROUTER_GET_DEVICE_INFO_ENDPOINT = "/ardevices/:deviceId";
export const AGRIROUTER_DELETE_DEVICE_ENDPOINT = "/ardevices/:deviceId";
export const AGRIROUTER_LOAD_DEVICES_ENDPOINT = "/ardevices/devices/ofCustomer/:customerId";
// EFDI status page endpoints
export const AGRIROUTER_GET_COMMUNICATIONS_STATUS_ENDPOINT = "/armessages/lastProcessed/ofCustomer/:customerId";
// TaskData messages page endpoints
export const AGRIROUTER_GET_MSGS_DONE_ENDPOINT = "/armessages/done/ofCustomer/:uidCustomer";
export const AGRIROUTER_GET_MSGS_IN_TRANSIT_ENDPOINT = "/armessages/intransit/ofCustomer/:uidCustomer";
export const AGRIROUTER_GET_MSGS_ACK_ENDPOINT = "/armessages/acknowledged/ofCustomer/:uidCustomer";
// send TaskData endpoints
export const AGRIROUTER_GET_FILE_UPLOADS_ENDPOINT = "/armessages/uploadfile/ofCustomer/:uidCustomer";
export const AGRIROUTER_GET_RECEIVERS_ENDPOINT = "/armessages/uploadfile/receivers/ofCustomer/:uidCustomer";
export const AGRIROUTER_UPLOAD_FILE_ENDPOINT = "/armessages/uploadfile/ofCustomer/:uidCustomer";
export const AGRIROUTER_SEND_UPLOADED_FILE_ENDPOINT = "/armessages/uploadfile/send";

export const VEHICLE_TYPES_ENDPOINT = "/common/vehicles";
export const HIDE_VEHICLE_ENDPOINT = "/hide/toggle";
export const ENGINE_TYPES_ENDPOINT = "/common/engines";
export const INSTALLATIONS_TYPES_ENDPOINT = "/common/installations";
export const ALL_PLANS_ENDPOINT = "/maintenance/plan";
export const Vehicle_FORCEDDD_ENDPOINT = "/vehicles/vehicle/forceDDD";
export const CMALIMITER = '/vehicles/ofCustomer/:uidCustomer/vehicle/:uidVehicle/cmalimiter'
export const VEHICLE_ASSIGN_ENDPOINT = "/vehicles/assign/toCustomer";
export const VEHICLE_UNASSIGN_ENDPOINT = "/vehicles/unassign?uidVehicles=";
export const TRACKING_FAULTS_ENDPOINT = "/fault/getFaultsByIdRaw/ofVehicle/:uidVehicle/ofIdRaw/:idRaw"

export const MISC_SIGNAL_OF_CUSTOMER = "/tracking/miscSignals/ofCustomer/:uidCustomer/vehicle/:uidVehicle"
export const SIGNAL_GETLATS_OF_CUSTOMER = "/signals/getLasts/ofCustomer/"
export const SIGNAL_GET_BY_DATE_RANGE = "/signals/getByDateRange/ofCustomer/"
export const MISC_DETAILS = "/tracking/miscDetails/ofCustomer/:uidCustomer/vehicle/:uidVehicle";
export const TRACKING_FIELDS_ENDPOINT = "/farm/ofCustomer/:uidCustomer/field"
export const TRACKING_MAP = "/tracking/map"
export const TRACKING_NEW_MAP = "/tracking/newMap"
export const DEVICES_ACTIVATION_ENDPOINT = "/devices/ofCustomer/:uidCustomer/activating/:active"
export const STARTWEBCALL_ENDPOINT = "/webcall/startwebcall"

//Dashboards Endpoints
export const DASHBOARD_CONFIG = "v1/rt/config";
export const SIGNALS_CATALOG = "v1/rt/catalog";
export const GENERAL_CATALOG = "v1/rt/config/general";
export const SIGNALS_FUNCTION = "v1/rt/functions/execute";
export const SIGNAL_DATA = "v1/rt/signal/data";
export const COMPOSITE_SIGNAL_DATA = "v1/rt/compositeSignal/data";
export const KPI_DATA = "v1/rt/kpi/data";
export const KPI_CUSTOM_DATA = "v1/rt/kpi/custom";
export const COMPOSITE_KPI_DATA = "v1/rt/compositeKpi/data";
export const MACHINE_DATA = "v1/rt/machine/data";
export const TABLE_STRUCTURE = "v1/rt/table/structure";
export const TABLE_DATA = "v1/rt/table/data";
/**/

//Report Endpoints
export const REPORT_TYPES = "api2.0/reporttypes";
export const USER_REPORTS = "api2.0/reports";
export const USER_REPORT = "api/reports/:id/user/:userId/platform/:platform";
export const SAVE_USER_REPORT = "api/reports/save";
export const GENERATE_USER_REPORT = "api2.0/reports/live-generate";
export const GENERATED_REPORTS = "api2.0/generated-reports";

/* Scope Normalization */
// export const SCOPE_NORMALIZATION_MAP: Record<string, string> = {
//   'kpi': 'platform',
//   'composite_kpi': 'platform',
//   'platform': 'platform',
//   'table': 'platform',
//   'composite_signal': 'platform',
//   'signal': 'signal',
//   'tcu': 'tcu',
//   'erp': 'erp',
//   'common': 'common',
//   'model': 'model',
//   'kpi_custom': 'kpi_custom',
//   'other': 'other'
// };


export const SCOPE_NORMALIZATION_MAP: Record<string, string> = {
  'kpi': 'kpi',
  'composite_kpi': 'kpi',
  'platform': 'platform',
  'table': 'table',
  'composite_signal': 'composite_signal',
  'signal': 'signal',
  'tcu': 'tcu',
  'erp': 'erp',
  'common': 'common',
  'model': 'model',
  'kpi_custom': 'kpi_custom',
  'other': 'other'
};


export function normalizeScope(scope: string): string {
  return SCOPE_NORMALIZATION_MAP[scope] ?? scope;
}

// Chiavi originali (pre-normalizzazione) che confluiscono in un dato scope normalizzato,
// es. 'kpi' raggruppa gli scope originali 'kpi' e 'composite_kpi'.
export function getOriginalScopeKeys(normalizedScope: string): string[] {
  const keys = Object.entries(SCOPE_NORMALIZATION_MAP)
    .filter(([, normalized]) => normalized === normalizedScope)
    .map(([original]) => original);
  return keys.length ? keys : [normalizedScope];
}
/**/

/* Field Mapping Scopes */
// Tutti i tipi di scope disponibili nel catalogo
export const CATALOG_FIELD_SCOPES = [
  'signal',
  'kpi',
  'tcu',
  'platform',
  'erp',
  'diagnostic',
  'maintenance',
  'fuel',
  'geolocation',
  'driver',
  'implement'
] as const;

// Scope specifici utilizzati dalla mappa
export const MAP_FIELD_SCOPES = [
  'signal',
  'tcu',
  'platform',
  'erp'
] as const;

// Scope specifici utilizzati dalla dashboard
export const DASHBOARD_FIELD_SCOPES = [
  'kpi',
  'kpi_custom',
  'signal','table','composite_signal','composite_kpi','erp','tcu','platform'
] as const;

// Scope specifici utilizzati dal journey
export const JOURNEY_FIELD_SCOPES = [
  'kpi',
  'kpi_custom'
] as const;

// Tipo TypeScript per gli scope del catalogo
export type CatalogFieldScope = typeof CATALOG_FIELD_SCOPES[number];

// Tipo TypeScript per gli scope della mappa
export type MapFieldScope = typeof MAP_FIELD_SCOPES[number];

// Tipo TypeScript per gli scope del journey
export type JourneyFieldScope = typeof JOURNEY_FIELD_SCOPES[number];

// Tipo TypeScript per gli scope della dashboard
export type DashboardFieldScope = typeof DASHBOARD_FIELD_SCOPES[number];

// Scope per widget tipo in specific config
export const WIDGET_SIGNAL_SCOPES = ['signal'] as const;
export const WIDGET_KPI_SCOPES = ['kpi', 'kpi_custom'] as const;
export const WIDGET_MACHINE_DATA_SCOPES = ['erp', 'signal', 'tcu', 'platform'] as const;
export const WIDGET_TABLE_SCOPES = ['table'] as const;
export const WIDGET_COMPOSITE_SIGNAL_SCOPE = 'composite_signal';
export const WIDGET_COMPOSITE_KPI_SCOPE = 'composite_kpi';
/**/

/*Patterns*/
export const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_NUMBER_PATTERN = /[0-9]{1,20}/;
/**/

/* Icons */
export const FILE_EXCEL_ICON = faFileExcel;
export const REFRESH_ICON = faRefresh;
export const PLUS_ICON = faPlus;
export const CLONE_ICON = faClone;
export const TRASH_ICON = faTrash;
export const BACK_ICON = faBackward;
export const FLOPPY_DISK_ICON = faFloppyDisk;
export const RIGHT_LEFT_ICON = faRightLeft;
export const CHECK_ICON = faCheck;
export const PEN_ICON = faPen;
export const BAN_ICON = faBan;
export const CHECK_CIRCLE_ICON = faCheckCircle;
export const WARNING_ICON = faWarning;
export const SEARCH_ICON = faMagnifyingGlass;
export const CIRCLE_EXCLAMATION_ICON = faCircleExclamation;
export const EYE_SLASH_ICON = faEyeSlash;
export const EYE_ICON = faEye;
export const DOUBLE_ARROW_ICON = faArrowRightArrowLeft;
export const BOX_ICON = faBoxArchive;
export const USD_ICON = faUsd;
export const INFO_ICON = faCircleInfo;
export const USER_SHIELD = faUserShield;
export const SCREW_DRIVER_WRENCH = faScrewdriverWrench;

/* Emails */
export const LANDINI_EMAIL = "atfleetmanager@argotractors.com";
export const MCCORMICK_EMAIL = "atfleetmanager@argotractors.com";
export const ARGO_EMAIL = "atfleetmanager@argotractors.com";
export const AFT_EMAIL = "actia.support@actiaitalia.com";
export const UCONTROL_EMAIL = "u.control.support@actiaitalia.com";
// TODO CELA: confermare la casella di supporto con il cliente
export const CELA_EMAIL = "info@cela.it";


// Colore di sfondo per il modulo adb_profile (default: grigio chiaro)
export const ADB_PROFILE_BACKGROUND_COLOR = "#f1f1f1";

/**/

export const ICON_STATE_MAPPER: any = {
    'administration': 'settings', //faCogs,
    'realtimeDriver': 'route', //faRoad,
    'tracking': 'location_on', //faLocationDot,
    'newtracking': 'location_on', //faLocationDot,
    'dashboardHistoricalLegalData': 'line_axis', //faLineChart,
    'dashboardHistoricalConsumption': 'water_drop', //faTint,
    'dashboardHistoricalFuelLevel': 'local_gas_station', //faGasPump,
    'farmbook': 'grass', //faSeedling,
    'tacho': 'agriculture', //faTractor,
    'timecard': 'credit_card', //faCreditCard,
    'faults': 'warning', //faExclamationTriangle,
    'vehicleMaintenance': 'event_available', //faCalendarCheck,
    'dataUsage': 'data_exploration', //faUserTie,
    'agrirouter': 'compare_arrows', //faArrowRightArrowLeft,
    'newCustomDashboardColl': 'dashboard', //faDashboard,
    'dashboards': 'dashboard', //faDashboard,
    'machineDashboard': 'precision_manufacturing', //faDashboard,
    'reports': 'assessment', //faAssessment,
    'trackingv2': 'location_on', //faLocationDot,
    'consumptionTrend20': 'show_chart',
    'home20': 'home',
    'ucontrolMonitoring':'monitoring',
    'ucontrolNfda': 'manage_accounts'
};

export const ROUTER_STATE_MAPPER: any = {
    'maintenanceOperations': "/app/maintenance/operations",
    'maintenancePlans': "/app/maintenance/plans",
    'maintenanceCustomPlan': "/app/maintenance/maintenanceCustomPlan",
    'maintenanceDeadlines': "/app/maintenance/deadlines",
    'dashboardHistoricalConsumption': "/app/fuel/dashboardHistoricalConsumption",
    'faults': '/app/faults',
    'silentDevices': "/app/statistics/silentdevices",
    'alertManagement': "/app/manage/alert",
    'adb_profile': "/app/manage/adb-profile",
    'users': "/app/manage/user",
    'teams': "/app/manage/team",
    'devices': "/app/manage/device",
    'devcfg': "/app/manage/deviceConfig",
    'fmwpckgs': "/app/manage/firmware",
    'fleets': "/app/manage/fleets",
    'drivers': "/app/manage/drivers",
    'groups': "/app/manage/groups",
    'customers': "/app/manage/customers",
    'brandModelsAdmin': "/app/manage/brandsModels",
    'canmaps': "/app/canmaps",
    'fields': "/app/farmbook/fields",
    'activityAccounting': "/app/farmbook/activityAccounting",
    'activityAccounting_old': "/app/farmbook/activityAccountingOld",
    'activityScheduling': "/app/farmbook/activityScheduling",
    'implements': "/app/manage/implements",
    'loginas': "/app/manage/loginas",
    'tracking': "/app/tracking",
    'ar_registry': "/app/agrirouter/registry",
    'ar_messages': "/app/agrirouter/messages",
    'ar_status': "/app/agrirouter/status",
    'vehicles': "/app/manage/vehicles",
    'ar_administration': "/app/agrirouter/administration",
    'vehiclemodels': "/app/manage/models",
    'newtracking': "/app/newTracking",
    'addNewCustomDashboard': "/app/dashboards/new_dashboard",
    'newCustomDashboardColl': "/app/dashboards/dashboard/",
    'adminDashboard': '/app/dashboards/admin/',
    "machineDashboard": '/app/dashboards/machine/',
    'reports': "/app/reports/",
    'report': "/app/reports/",
    'scheduledReport': "/app/reports/scheduled",
    'generatedReport': "/app/reports/generated",
    'trackingv2': "/app/actiaMap",
    'portalSettings': "/app/manage/portalSettings",
    'consumptionTrend20': '/app/fuel/consumption-trend20',
    'home20': '/app/home20',
    'ucontrolMonitoring': '/app/ucontrol/monitoring',
    'ucontrolConfig':'/app/ucontrol/config',
    'ucontrolNfda': '/app/ucontrol/nfda',

    // Old mappings based on environment enabled/disabled - to be deprecated
    /* 'collaudo_maintenanceOperations': "/app/maintenance/operations",
    'prod_maintenanceOperations': "/app/maintenance/operations",
    'collaudo_maintenancePlans': "/app/maintenance/plans",
    'prod_maintenancePlans': "/app/maintenance/plans",
    'collaudo_maintenanceCustomPlan': "/app/maintenance/maintenanceCustomPlan",
    'prod_maintenanceCustomPlan': "/app/maintenance/maintenanceCustomPlan",
    'collaudo_maintenanceDeadlines': "/app/maintenance/deadlines",
    'prod_maintenanceDeadlines': "/app/maintenance/deadlines",
    'collaudo_dashboardHistoricalConsumption': "/app/fuel/dashboardHistoricalConsumption",
    'prod_dashboardHistoricalConsumption': "/app/fuel/dashboardHistoricalConsumption",
    'collaudo_faults': '/app/faults',
    'prod_faults': '/app/faults',
    'collaudo_silentDevices': "/app/statistics/silentdevices",
    'prod_silentDevices': "/app/statistics/silentdevices",
    'collaudo_alertManagement': "/app/manage/alert",
    'prod_alertManagement': "/app/manage/alert",
    'collaudo_users': "/app/manage/user",
    'prod_users': "/app/manage/user",
    'collaudo_teams': "/app/manage/team",
    'prod_teams': "/app/manage/team",
    'collaudo_devices': "/app/manage/device",
    'prod_devices': "/app/manage/device",
    'collaudo_devcfg': "/app/manage/deviceConfig",
    'prod_devcfg': "/app/manage/deviceConfig",
    'collaudo_fmwpckgs': "/app/manage/firmware",
    'prod_fmwpckgs': "/app/manage/firmware",
    'collaudo_fleets': "/app/manage/fleets",
    'prod_fleets': "/app/manage/fleets",
    'collaudo_drivers': "/app/manage/drivers",
    'prod_drivers': "/app/manage/drivers",
    'collaudo_groups': "/app/manage/groups",
    'prod_groups': "/app/manage/groups",
    'collaudo_customers': "/app/manage/customers",
    'prod_customers': "/app/manage/customers",
    'collaudo_brandModelsAdmin': "/app/manage/brandsModels",
    // 'prod_brandModelsAdmin': "/app/manage/brandsModels",
    'collaudo_canmaps': "/app/canmaps",
    'prod_canmaps': "/app/canmaps",
    'collaudo_fields': "/app/farmbook/fields",
    'prod_fields': "/app/farmbook/fields",
    'collaudo_activityAccounting': "/app/farmbook/activityAccounting",
    'prod_activityAccounting': "/app/farmbook/activityAccounting",
    'collaudo_activityAccounting_old': "/app/farmbook/activityAccountingOld",
    'prod_activityAccounting_old': "/app/farmbook/activityAccountingOld",
    'collaudo_activityScheduling': "/app/farmbook/activityScheduling",
    'prod_activityScheduling': "/app/farmbook/activityScheduling",
    'collaudo_implements': "/app/manage/implements",
    'prod_implements': "/app/manage/implements",
    'collaudo_loginas': "/app/manage/loginas",
    'prod_loginas': "/app/manage/loginas",
    'collaudo_tracking': "/app/tracking",
    'prod_tracking': "/app/tracking",
    'collaudo_ar_registry': "/app/agrirouter/registry",
    'prod_ar_registry': "/app/agrirouter/registry",
    'collaudo_ar_messages': "/app/agrirouter/messages",
    'prod_ar_messages': "/app/agrirouter/messages",
    'collaudo_ar_status': "/app/agrirouter/status",
    'prod_ar_status': "/app/agrirouter/status",
    'collaudo_vehicles': "/app/manage/vehicles",
    'prod_vehicles': "/app/manage/vehicles",
    'collaudo_ar_administration': "/app/agrirouter/administration",
    'prod_ar_administration': "/app/agrirouter/administration",
    'collaudo_vehiclemodels': "/app/manage/models",
    'prod_vehiclemodels': "/app/manage/models",
    'collaudo_newtracking': "/app/newTracking",
    'prod_newtracking': "/app/newTracking",
    'collaudo_addNewCustomDashboard': "/app/dashboards/new_dashboard",
    'prod_addNewCustomDashboard': "/app/dashboards/new_dashboard",
    'collaudo_newCustomDashboardColl': "/app/dashboards/dashboard/",
    'prod_newCustomDashboardColl': "/app/dashboards/dashboard/",
    'collaudo_adminDashboard': '/app/dashboards/admin/',
    "prod_adminDashboard": '/app/dashboards/admin/',
   // "collaudo_machineDashboard": '/app/dashboards/machine/',
   // "prod_machineDashboard": '/app/dashboards/machine/',
    'collaudo_reports': "/app/reports/",
    // 'prod_reports': "/app/reports/",
    'collaudo_trackingv2': "/app/actiaMap",
    // 'prod_trackingv2': "/app/actiaMap", */
};


export const LANGUAGES: any[] = [
  { key: "en", value: "English", img: 'assets/images/flags/en.svg' },
  { key: "fr", value: "Français", img: 'assets/images/flags/fr.svg' },
  { key: "it", value: "Italiano", img: 'assets/images/flags/it.svg' },
  { key: "de", value: "Deutsch", img: 'assets/images/flags/de.svg' },
  { key: "es", value: "Español", img: 'assets/images/flags/es.svg' },
  { key: "pt", value: "Português", img: 'assets/images/flags/pt.svg' }
];

export const DEADLINE_TYPES: any = [{ name: "Once" }, { name: "Periodic" }];

// Route che richiedono getCompleteStateAllAssets (tutti gli asset inclusi children)
// Le pagine in questo array riceveranno TUTTI gli asset dallo store, inclusi quelli con isChild=true
// Le altre pagine useranno getCompleteState che filtra solo gli asset principali (isChild=false)
export const ROUTES_REQUIRING_ALL_ASSETS: string[] = [
  '/app/actiaMap',
  '/app/dashboards/dashboard',
  '/app/dashboards/new_dashboard'
  // aggiungere altre route se necessario
];

/**
 * Deriva il tenant dal flag isArgo gia' presente in localStorage['user']
 * (salvato da DataService.setCurrentUserInfo al login) - nessuna chiave dedicata da mantenere.
 *
 * Il default e' true (= tenant Argo/agri, moduli "vecchi": home, consumption-trend): finche' non
 * sappiamo chi e' l'utente - localStorage vuoto, isArgo assente o JSON corrotto - mostriamo la
 * versione storica. Solo un isArgo esplicitamente falso porta ai moduli 2.0.
 */
export function isAgriTenant(): boolean {
  try {
    const isArgo = JSON.parse(localStorage.getItem('user') || '{}').isArgo;
    return isArgo === undefined || isArgo === null ? true : !!isArgo;
  } catch {
    return true;
  }
}
